<template>
    <div class="content container-fluid">
        <!-- Page Header -->
        <div class="page-header">
            <div class="row align-items-center">
                <div class="col">
                    <h3 class="page-title">Leave Reason (Corporate)</h3>
                </div>
            </div>
        </div>
        <!-- /Page Header -->

        <!-- Table List -->
        <div class="row">
            <div class="col-md-12">
                <div class="row align-items-center">
                    <div class="col-md-1 fit-content">Company</div>
                    <div class="col-md-5 pl-md-0 fit-content">
                        <select class="form-control" v-model="company" @change="changeCompany">
                            <option v-for="company in companies" :key="company.CompanyName"
                                :value="company.CompanyName">
                                {{ company.CompanyName }}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1 mt-4">
                    <table style="width: auto !important" class="table table-bordered custom-table mb-0">
                        <thead class="thead-light">
                            <tr>
                                <th class="text-center" style="width: 800px">Leave Reason (Corporate)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, i) in leaveReasons" :key="item.Id">
                                <td class="text-center" style="position: relative">
                                    <input type="text" v-model="item.Reason" class="form-control height26 text-center"
                                        maxlength="1000" required />
                                    <span @click="removeLeaveReason(i)" style="
                                        position: absolute;
                                        right: -8px;
                                        top: 6px;
                                        color: #ff0000;
                                        cursor: pointer;">
                                        <i class="fa fa-minus-circle"></i>
                                    </span>
                                </td>
                            </tr>

                            <tr v-for="(item, i) in newLeaveReasons" :key="i">
                                <td class="text-center" style="position: relative">
                                    <input type="text" v-model="item.Reason" class="form-control height26 text-center"
                                        maxlength="1000" required />
                                    <span @click="removeNewLeaveReason(i)" style="
                                        position: absolute;
                                        right: -8px;
                                        top: 6px;
                                        color: #ff0000;
                                        cursor: pointer;">
                                        <i class="fa fa-minus-circle"></i>
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td class="text-center" colspan="5">
                                    <button type="button" class="btn btn-primary" @click="addLeaveReason">
                                        <i class="fa fa-plus"></i> Add Leave Reason
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="row mt-4">
                    <div class="col-md-12">
                        <button @click="save" type="button" class="btn btn-primary">
                            <i class="fa fa-save"></i>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- /Table List -->
    </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";
export default {
    data() {
        return {
            company: config.DEFAULT_COMPANY,
            companies: [],
            leaveReasons: [],
            newLeaveReasons: [],
        };
    },
    computed: {
        token() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.Token;
        },
        role() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.Role;
        },
    },
    methods: {
        addLeaveReason() {
            this.newLeaveReasons.push({
                Id: "",
                Reason: ""
            });
        },
        removeNewLeaveReason(index) {
            this.newLeaveReasons.splice(index, 1);
        },
        removeLeaveReason(index) {
            this.leaveReasons.splice(index, 1);
        },
        changeCompany() {
            this.getLeaveReasons();
        },
        getCompanies() {
            let param = {
                Token: this.token,
            };
            this.$store.state.isLoading = true;
            API.getCompanies(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        this.companies = response.data.record;
                        //this.company = this.companies[0].CompanyName;
                        this.getLeaveReasons();
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        getLeaveReasons() {
            let param = {
                Token: this.token,
                Company: this.company,
            };
            this.$store.state.isLoading = true;
            API.getLeaveReasonsCorporate(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        if (response.data.record) this.leaveReasons = response.data.record;
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        save() {
            //check duplicate leave reason
            let allLeaveReasons = this.leaveReasons.concat(this.newLeaveReasons);
            for (let item of allLeaveReasons) {
                if (item.Reason) {
                    let records = allLeaveReasons.filter(
                        (c) => c.Reason == item.Reason
                    );
                    if (records && records.length > 1) {
                        alert(`Leave Reason: ${item.Reason} is duplicated.`);
                        return;
                    }
                }
            }

            let param = {
                Token: this.token,
                Company: this.company,
                LeaveReasons: this.leaveReasons,
                NewLeaveReasons: this.newLeaveReasons,
            };
            this.$swal({
                title: "Are you sure?",
                text: "Are you sure you want to save the leave reason?",
                icon: "info",
                buttons: true,
                dangerMode: false,
            }).then((willSave) => {
                if (willSave) {
                    this.$store.state.isLoading = true;
                    API.saveLeaveReasonsCorporate(param)
                        .then((response) => {
                            this.$store.state.isLoading = false;
                            this.$swal(response.data.message, {
                                icon: response.data.success ? "success" : "error",
                            });
                            this.leaveReasons = [];
                            this.newLeaveReasons = [];
                            this.getLeaveReasons();
                        })
                        .catch((error) => {
                            console.log(error);
                            this.$store.state.isLoading = false;
                            this.$swal(error.response.data.Message, { icon: "error" });
                        });
                }
            });
        },
    },
    created() {
        if (this.role != "admin") this.$router.replace({ name: "home" });
        this.getCompanies();
    },
};
</script>

<style scoped>
.fit-content {
    max-width: fit-content;
}
</style>


// WEBPACK FOOTER //
// src/components/Leave/LeaveReasonCorporate.vue